import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../components/Navbar";
import OwnPosition from "../../components/StudentPortal/Leaderboard/OwnPosition";
import ResultRanking from "../../components/StudentPortal/Leaderboard/ResultRanking";
import { leaderboardApi } from "../../features/leaderboard/leaderboardApi";
import { useGetUsersQuery } from "../../features/users/usersApi";

export default function Leaderboard() {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { data: users } = useGetUsersQuery() || {};

  const [leaderboardData, setLeaderboardData] = useState([]);

  useEffect(() => {
    if (users) {
      const fetchData = async (user) => {
        const studentId = user.id;
        const { data: assignmentMarks } =
          (await dispatch(
            leaderboardApi.endpoints.getAssignmentMarks.initiate(studentId)
          )) || {};
        const { data: quizMarks } =
          (await dispatch(
            leaderboardApi.endpoints.getQuizMarks.initiate(studentId)
          )) || {};

        const totalQuizMarks = quizMarks?.reduce(
          (total, quiz) => total + quiz.mark,
          0
        );

        const quizTotal = totalQuizMarks ? totalQuizMarks : 0;

        const totalAssignmentMarks = assignmentMarks?.reduce(
          (total, assignment) => total + assignment.mark,
          0
        );

        const assignmentTotal = totalAssignmentMarks ? totalAssignmentMarks : 0;

        const total = quizTotal + assignmentTotal;

        return {
          rank: 0,
          student_id: user.id,
          student_name: user.name,
          quizTotal,
          assignmentTotal,
          total,
        };
      };

      const fetchDataForUsers = async () => {
        const filteredUsers = users.filter((user) => user.role !== "admin");
        const data = await Promise.all(filteredUsers.map(fetchData));

        // Filter out items with missing data
        const filteredData = data.filter(
          (item) => item.quizTotal != null && item.assignmentTotal != null
        );

        // Sort data by total marks in descending order
        filteredData.sort((a, b) => b.total - a.total);

        // Update ranks
        filteredData.forEach((item, index) => {
          if (index > 0 && item.total === filteredData[index - 1].total) {
            item.rank = filteredData[index - 1].rank;
          } else {
            item.rank = index + 1;
          }
        });

        setLeaderboardData(filteredData);
      };

      fetchDataForUsers();
    }
  }, [users, dispatch]);

  const ownRank = leaderboardData.find(
    (userData) => userData.student_id === user.id
  );

  return (
    <>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <OwnPosition ownRank={ownRank} />

          <ResultRanking allRank={leaderboardData} />
        </div>
      </section>
    </>
  );
}
